// extracted by mini-css-extract-plugin
export default {"deviceAccessContainer":"DeviceAccess_deviceAccessContainer__+AEyb","singleDeviceContainer":"DeviceAccess_singleDeviceContainer__KGsxb"};